export const FilterableGridFragment = `
  _key,
  defaultSortingOption,
  filters,
  introCopy,
  title
`;
